import { useState } from "react";
import toast from "react-hot-toast";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    mobile: "",
    service: "Web Development",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name);
    console.log(value);
    setFormData({
      ...formData,
      [name]: value,
    });
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  const nameParts = formData.fullName.trim().split(" ");
  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(" ");

  const payload = {
    firstName: firstName,
    lastName: lastName,
    email: formData.email,
    phone: formData.mobile,
    message: formData.message,
  };

  try {
    const response = await fetch(
      "https://azerotech.com/api/sendContact.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json", // ✅ JSON POST
        },
        body: JSON.stringify(payload),
      }
    );

    // ✅ Response is NOT JSON
    const resultText = await response.text();
    console.log("Server Response:", resultText);

    if (!response.ok) {
      throw new Error("Request failed");
    }

    // ✅ Clear form after success
    setFormData({
      fullName: "",
      email: "",
      mobile: "",
      service: "Web Development",
      message: "",
    });

    toast.success("Message sent successfully!");
  } catch (error) {
    console.error(error);
    toast.error("Failed to send message");
  }
};



  return (
    <section className="max-w-[1100px] mx-auto md:px-6 py-10">
      <h2 className="text-center text-[30px] md:text-[40px] uppercase mb-4 font-bold text-primary">
        Drop Us a Line
      </h2>

      <p className="text-center text-black font-semibold text-[12px] md:text-[30px] mb-16">
        Reach out to us from our contact form and we will get back to you
        shortly.
      </p>

      <form onSubmit={handleSubmit} className="space-y-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <label className="block text-gray-500 mb-2">
              Full Name <span className="text-black">*</span>
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              className="w-full border-b border-gray-400 outline-none py-2 focus:border-black text-black bg-transparent "
            />
          </div>

          <div>
            <label className="block text-gray-500 mb-2">
              Email <span className="text-black">*</span>
            </label>
            <input
              type="text"
              name="email"
              value={formData.email}
              required
              onChange={handleChange}
              className="w-full border-b border-gray-400 outline-none py-2 focus:border-black text-black bg-transparent"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <label className="block text-gray-500 mb-2">
              Mobile Number <span className="text-black">*</span>
            </label>
            <input
              type="number"
              name="mobile"
              required
              value={formData.mobile}
              onChange={handleChange}
              className="w-full border-b border-gray-400 outline-none py-2 focus:border-black text-black bg-transparent"
            />
          </div>

          <div>
            <label className="block text-gray-500 mb-2">Service</label>
            <select
              name="service"
              required
              value={formData.service}
              onChange={handleChange}
              className="w-full border-b border-gray-400 outline-none py-2 bg-transparent focus:border-black text-black"
            >
             
            
              <option>Looking for job</option>
              <option>General Enquiry</option>
              <option>Others</option>
              <option>Business Partnership</option>
            </select>
          </div>
        </div>

        <div>
          <label className="block text-gray-500 mb-2">
            Message <span className="text-black">*</span>
          </label>
          <textarea
            rows="4"
            name="message"
            required
            value={formData.message}
            onChange={handleChange}
            className="w-full border-b border-gray-400 outline-none py-2 resize-none focus:border-black text-black bg-transparent"
          />
        </div>

        <div className="flex justify-center">
          <div className="w-[200px] h-[50px]">
            <button
              type="submit"
              className="bg-primary w-full h-full rounded-xl text-white font-semibold"
            >
              Send Message
            </button>
          </div>
        </div>
      </form>
    </section>
  );
};

export default ContactForm;
